
import { Box, Typography } from '@mui/material'

import InfoOutlineIcon from "@mui/icons-material/InfoOutline";

interface Props {
    message:                string;
}

export const BoxTurnos = ( { message }: Props ) => {

    return (
       <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            width={'100%'}
            height={280}
        >
            <Box sx={{ textAlign: 'center', }}>    

                <InfoOutlineIcon sx={{ fontSize: 130, mb: 3 }} />

                <Typography variant="h6" fontWeight="bold" gutterBottom>
                    { message }
                </Typography> 

            </Box>

        </Box>
    )
}